import { module } from 'modujs';
import { $html } from '../utils/dom'
import * as focusTrap from 'focus-trap';

const CLASS = {
    OPEN: `has-menu-open`,
}

export default class extends module {
    constructor(m) {
        super(m);

        // Binding
        this.onItemHoverBind = this.onItemHover.bind(this)

        // UI
        this.$list = this.$('list')
        this.$items = this.$('item')
        this.$links  = Array.from(this.$('link'))

        this.events = {
            click: {
                'close': 'closeMenu'
            }
        }

        this.canOpen = true;
    }

    ///////////////
    // Lifecyle
    ///////////////
    init() {
        this.updateCurrentLink()
        this.bindEvents()

        this.focusTrap = focusTrap.createFocusTrap([this.el, '.c-header'], {
            onDeactivate: this.closeMenu.bind(this),
            clickOutsideDeactivates: true,
        });
    }

    destroy() {
        this.unbindEvents()
    }

    ///////////////
    // Events
    ///////////////
    bindEvents() {
        for (const $item of this.$items) {
            $item.addEventListener('mouseenter', this.onItemHoverBind)
        }
    }

    unbindEvents() {
        for (const $item of this.$items) {
            $item.removeEventListener('mouseenter', this.onItemHoverBind)
        }
    }

    ///////////////
    // Callbacks
    ///////////////
    toggle() {
        if($html.classList.contains(CLASS.OPEN)) {
            this.closeMenu();
            this.call('closeMenu', null, 'Header')
        } else {
            this.openMenu();
            this.call('openMenu', null, 'Header')
        }
    }

    openMenu() {
        this.$('scroll')[0].scrollTop = 0

        if(!this.canOpen) return;

        $html.classList.add(CLASS.OPEN)

        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                this.focusTrap?.activate()
            })
        })
    }

    closeMenu() {
        this.canOpen = false;
        setTimeout(() => {
            this.canOpen = true;
        }, 250);

        $html.classList.remove(CLASS.OPEN)
        this.focusTrap?.deactivate()
    }

    onItemHover(e) {
        const $item = e.currentTarget
        const height = $item.clientHeight
        const offset = $item.offsetTop

        this.el.style.setProperty('--item-height', `${ height }px`)
        this.el.style.setProperty('--item-offset', `${ offset }px`)
    }


    updateCurrentLink(pathname = location.pathname) {
        let index = 0
        while (index < this.$links.length) {
            const $link = this.$links[index]

            // Remove current class
            $link.classList.remove('is-current')

            // Get main link href
            const linkUrl = $link.getAttribute('href')

            // Add current class
            if (pathname.replace(/^\/|\/$/g, '') == linkUrl) $link.classList.add('is-current')

            index++
        }
    }
}
